/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "CasesApplicationType": [
      "DisabilityApplication",
      "HomeAndAutoApplication",
      "LifeApplication"
    ],
    "CommunicationsFeedItem": [
      "CaseEventFeedItem",
      "CaseUpdateFeedItem",
      "ChatFeedItem",
      "EmailFeedItem",
      "InternalNoteFeedItem",
      "MilestoneUpdateFeedItem",
      "PacketFeedItem",
      "PhoneCallFeedItem",
      "SecureMessageFeedItem",
      "SmsFeedItem",
      "TaskUpdateFeedItem"
    ],
    "ContactInfoConfirmation": [
      "Client"
    ],
    "OtherConditionProfile": [
      "HeartAttackProfile",
      "StrokeProfile"
    ],
    "PersonalInfoConfirmation": [
      "Client"
    ]
  }
};
      export default result;
    